export const environment = {
  production: false,
  env: 'dev',
  useEmulators: {
    auth: false,
    firestore: false,
    functions: false,
    storage: false,
  },
  firebase: {
    apiKey: 'AIzaSyDJnyD9LSeLey4umR4HYHPvmQGSSlLAJD8',
    authDomain: 'current-ly-connected.firebaseapp.com',
    projectId: 'current-ly-connected',
    storageBucket: 'current-ly-connected.firebasestorage.app',
    messagingSenderId: '217032445876',
    appId: '1:217032445876:web:cdf786707b355fd5262ce1',
    measurementId: 'G-6Z5BMBEZ6B',
  }
};
